import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalf } from '@fortawesome/free-solid-svg-icons';

/** TO BE FINISHED! **/

export default function StarRatingInput ({ key, name, label, defaultValue=0.0 }) {

  const [ rating, setRating ] = useState(defaultValue);

  return(
    <div>
      <input type="hidden" value={rating} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStarHalf} />
    </div>
  );
}